import { createSelector } from 'reselect';
import { defaultCalculationData } from '../../constants/productsDefaultData/employeeHealthcare/defaultData';
import { get } from 'lodash';

const calculationOut = state =>
    state.calculationData.calculatedData.calculationOut;

const firstStepForm = state => state.form.firstStep;

const detailsPanelForm = state => state.form.detailsPanel;

const buyingInformationForm = state => state.form.buyingInformation;

export const updateCalculationData = createSelector(
    calculationOut,
    firstStepForm,
    detailsPanelForm,
    buyingInformationForm,
    (
        calculationOut,
        firstStepForm,
        detailsPanelForm,
        buyingInformationForm
    ) => ({
        calculation: {
            ...defaultCalculationData,
            ...firstStepForm.values,
            ...(detailsPanelForm ? detailsPanelForm.values : {}),
            paymentTerm: get(
                buyingInformationForm,
                'values.paymentTerm',
                defaultCalculationData.paymentTerm
            ),
            startDate: (() => {
                let startDate = get(buyingInformationForm, 'values.startDate');
                return startDate
                    ? startDate.toISOString().slice(0, 10)
                    : undefined;
            })(),
            customerPhone: get(buyingInformationForm, 'values.telephone'),
            customerEmail: get(buyingInformationForm, 'values.email')
        },
        calculationOut
    })
);
